import {Injectable} from '@angular/core';
import {Filter} from '../../components/table/interfaces/filter.interface';
import {Utils} from "../../utils/utils.class";
import * as dot from 'dot-prop';

@Injectable()
export class OfflineTableFilterService {
  public filterElements(elements: any[], filters: Filter[]): any[] {
    let data = JSON.parse(JSON.stringify(elements));
    if (filters && filters.length) {
      filters.forEach(filter => {
        const filterType = filter.type;
        const filterValue = filter.value;
        if (filterValue) {
          data = data.filter((element) => {
            const elementValue: string = dot.get(element, filter.key)
            if (filterType === 'string') {
              return elementValue.toLowerCase().includes(filterValue.toLowerCase());
            }
            if (filterType === 'date from') {
              return new Date(elementValue).getTime() >= new Date(filterValue).getTime();
            }
            if (filterType === 'date to') {
              return new Date(elementValue).getTime() <= new Date(filterValue).getTime();
            }
            if (filterType === 'EQUALS' || filterType === 'STRING') {
              return elementValue === filterValue;
            }
            return false;
          });
        }
      });
    }
    return data;
  }

  public filterBySearchQuery(elements: any[], searchQuery: string): any[] {
    const result = elements.filter(
      (element) => Utils.checkAgainstQuery(element, searchQuery)
    );
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/filters/offline-table-filter.service.ts